export default __webpack_public_path__ + "static/blob9-7d6e80e1e754bb24257199057e2b3459.svg";